export default __webpack_public_path__ + "static/nbc-1-23cba9ec64e732151c695677a7512e3b.svg";